import Titulo from './components/Titulo';
import './styles/App.css';
import Pie from './components/Pie';
import Cuerpo from './components/Cuerpo';

function App() {
  return (
    <div className="Principal">
      <header>
        <Titulo />
      </header>
      <body>
        <Cuerpo />
      </body>
      <footer>
        <Pie />
      </footer>
    </div>
  );
}

export default App;
